var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3333C0 24.2538 0.746192 25 1.66667 25H28.3333C29.2538 25 30 24.2538 30 23.3333C30 22.4129 29.2538 21.6667 28.3333 21.6667H1.66667C0.746193 21.6667 0 22.4129 0 23.3333ZM0 15C0 15.9205 0.746192 16.6667 1.66667 16.6667H28.3333C29.2538 16.6667 30 15.9205 30 15C30 14.0795 29.2538 13.3333 28.3333 13.3333H1.66667C0.746193 13.3333 0 14.0795 0 15ZM1.66667 5C0.746193 5 0 5.74619 0 6.66667C0 7.58714 0.746192 8.33333 1.66667 8.33333H28.3333C29.2538 8.33333 30 7.58714 30 6.66667C30 5.74619 29.2538 5 28.3333 5H1.66667Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClosed);
export default __webpack_public_path__ + "static/media/menu_closed.14e1b2785d2d8bc54d2e21ea7f813b48.svg";
export { ForwardRef as ReactComponent };